import React, { useState } from 'react'
import { Box, Modal, Rating } from '@mui/material'
import PlaceholderImage from '../../assets/imgs/no-image-placeholder.jpg'
import StarImage from '../../assets/imgs/star-icon.svg'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  // bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const ReviewCard = ({ classes, review }) => {
  const [viewReviewImageModal, setViewReviewImageModal] = useState(false)
  const [selectedImage, setSelectedImage] = useState('')
  return (
    <div className="position-relative">
      <img
        src={review?.image ?? PlaceholderImage}
        alt=""
        className="pointer w-100"
        style={{ borderRadius: '20px', objectFit: 'cover' }}
        height={248}
        onClick={() => {
          setSelectedImage(review?.image ?? PlaceholderImage)
          setViewReviewImageModal(true)
        }}
      />
      <div
        className={`reviews-card ${classes} position-relative`}
        style={{ margin: '-2.2rem auto 0 auto', width: '100%' }}
      >
        <div className="d-flex align-items-center position-relative flex-wrap">
          <img
            src={review?.user?.profile_image}
            // alt="Reviwer Profile"
            width={73}
            height={73}
            style={{ borderRadius: '50%', objectFit: 'cover' }}
          />
          <div className="d-inline-block" style={{ marginLeft: '10px' }}>
            <h3 className="fs-34 text-black m-0 fw-bold">
              {review?.review_by}
            </h3>
            <p className="d-flex align-items-center gap-1">
              <Rating name="rating" value={review?.rating || 0} readOnly size='small' sx={{color: 'goldenrod'}} />
              <span className="fs-6 fw-bold">({review?.rating})</span>
            </p>
          </div>
        </div>
        <p
          className="fs-18 m-0 mt-2 opacity-50"
          style={{ marginLeft: '10px !important', wordBreak: 'break-all' }}
        >
          {review?.comment}
        </p>
      </div>
      <Modal
        open={viewReviewImageModal}
        onClose={() => setViewReviewImageModal(false)}
      >
        <Box sx={style} className="about-me-modal">
          <img src={selectedImage} alt="" />
        </Box>
      </Modal>
    </div>
  )
}

export default ReviewCard
